module.exports = __webpack_public_path__ + "mma_icon.embedded.svg?ffa03e73df594283545673ae9f14e66d";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/mma_icon.embedded.svg
// module id = 1321
// module chunks = 35